export function download(resource, id, action, config, $resource, HeadersUtil, payload, query, newTab) {
  return new Promise((resolve, reject) => {
    var baseUrl = `${config.serverURL}/:resource/:subresource/:id/:action`;

    let baseParams = {
      id: '@id',
      action: '@action',
      subresource: '@subresource',
      resource
    };

    if (query) {
      baseParams = Object.assign({}, baseParams, query);
    }

    let service = $resource(baseUrl, baseParams, {
      descargar: {
        method: 'POST',
        responseType: 'arraybuffer',
        transformResponse: function(data, headers) {
          var file;
          if (data) {
            file = new Blob([data], {
              type: HeadersUtil.getHeaderContentType(headers)
            });
          }
          return {
            file: file,
            filename: HeadersUtil.getHeaderFilename(headers)
          };
        }
      }
    });

    if (!payload) {
      payload = {};
    }

    let base = new service(payload);
    base.$descargar({ id, action })
      .then(function(response) {
        var url = URL.createObjectURL(response.file);
        if (newTab) {
          window.open(url, '_blank');
        } else {
          var a = document.createElement('a');
          a.href = url;
          a.download = response.filename;
          a.target = '_blank';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
        resolve();
      })
      .catch(error => reject(error));
  });
}



// WEBPACK FOOTER //
// ./src/core/util/download.js